import { CONST } from ".";

export const Table001 = {
    Headers : {    
      backgroundColor: CONST.Colors.Primary.Main,
      color: '#fff',
      fontSize: 'large',
    },
    HeadersXS : {    
        backgroundColor: CONST.Colors.Primary.Main,
        color: '#fff',
        fontSize: 'tiny',
    },
    HeaderSearch : {    
        backgroundColor: CONST.Colors.Primary.Main,
        color: '#fff',
        fontSize: 'large',
        flexDirection: 'column',
        alignContent: 'flex-start',
    },
    HeaderSearchField : {    
        backgroundColor: '#fff',
        borderRadius: 2
    }
};

export const Buttons = {
    SimpleIcon: {
        color: '#fff',
        backgroundColor: CONST.Colors.Primary.Main,
        borderRadius: 10,
        border: `1px solid ${CONST.Colors.Primary.Main}`,
    }
}